import React from "react";

import cn from "classnames";

import { boxForwardRef } from "../../../../../helpers/common/Box/Box";
import { TextCore } from "../../../../../helpers/common/TextCore/TextCore";
import { createDisplayNameForButtonCircleElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCircleElement } from "../../utils/getTestId";

import type { BoxComponentWithDefault } from "../../../../../helpers/common/Box/Box";
import type { TextProps } from "../../../../Text";

import classes from "./ButtonCircleLabel.styl";

const name = "Label";
const displayName = createDisplayNameForButtonCircleElement(name);
const testId = createTestIdForButtonCircleElement(name);

export type ButtonCircleLabelProps = Omit<
    TextProps,
    | "textCase"
    | "underline"
    | "strikethrough"
    | "width"
    | "alignmentX"
    | "truncateStyle"
    | "typographyStyle"
    | "lineHeight"
    | "italic"
    | "asList"
    | "quote"
> & { truncateStyle?: "fade" | "ellipsis" };

export const ButtonCircleLabel = boxForwardRef<
    BoxComponentWithDefault<"span", ButtonCircleLabelProps, "className">
>(
    (
        {
            typographyStyle,
            maxLines,
            children,
            truncateStyle = "fade",
            ...props
        },
        ref,
    ) => {
        return (
            <TextCore
                data-tsid={testId}
                {...props}
                truncateStyle={truncateStyle === "fade" ? "none" : "ellipsis"}
                maxLines={maxLines || 2}
                typographyStyle={typographyStyle || "caption-m"}
                textContainerClassName={cn(
                    classes["label"],
                    truncateStyle === "fade" && classes["__fade"],
                )}
                width="100%"
                ref={ref}
            >
                {children}
            </TextCore>
        );
    },
);

ButtonCircleLabel.displayName = displayName;

export default ButtonCircleLabel;
